import React from "react";
import { Datagrid, FunctionField, ResourceContextProvider } from "react-admin";
import CustomDateField from "../../../components/CustomDateField";
import StatusField from "../../../components/StatusField";
import UpdatedByField from "../../../components/UpdatedByField";
import CustomPriceField from "../../../components/CustomPriceField";
import CustomPagination from "../../../components/CustomPagination";
import EmptyComponent from "./EmptyComponent";
import SanitizedGrid from "../../../components/SanitizedGrid";
import { Grid, Typography } from "@material-ui/core";
import { PaddingDenseStyled2List } from "../../../components/ListWrapper";

interface ISubcontractorAdjustmentPriceStatusLogTable {
  basePath: string;
  filter?: any;
  showOldAndNewStatus?: boolean;
  showPagination?: boolean;
  title?: string;
  loggedAtSource?: string;
  staticRemark?: string;
  pageSize?: number;
}

// Table layout for single "Status" column
const CustomOneColumnStatusDatagrid = ({
  loggedAtSource,
  staticRemark,
}: any) => {
  return (
    <Datagrid>
      <CustomDateField
        source={loggedAtSource}
        label="Logged At"
        emptyText="-"
        isDateTime
      />
      <FunctionField
        label="Status"
        render={(record: any) => (
          <>{record.status === null ? "-" : <StatusField source="status" />}</>
        )}
      />
      <CustomPriceField label="Adjustment Amount" source="price" />
      <FunctionField
        label="Remark"
        render={(record: any) =>
          staticRemark ? staticRemark : record?.remark || "-"
        }
      />

      <FunctionField
        label="Updated By"
        render={(record: any) => (
          <>
            {record.updatedBy === null ? (
              "-"
            ) : (
              <UpdatedByField data={record.updatedBy} />
            )}
          </>
        )}
      />
    </Datagrid>
  );
};

// Table layout for two columns status, "Old Status" and "New Status" columns
const CustomTwoColumnStatusDatagrid = ({
  loggedAtSource,
  staticRemark,
}: any) => {
  return (
    <Datagrid>
      <CustomDateField
        source={loggedAtSource}
        label="Logged At"
        emptyText="-"
        isDateTime
      />
      <FunctionField
        label="Old Status"
        render={(record: any) => (
          <>
            {record.oldStatus === null ? (
              "-"
            ) : (
              <StatusField source="oldStatus" />
            )}
          </>
        )}
      />
      <FunctionField
        label="New Status"
        render={(record: any) => (
          <>
            {record.newStatus === null ? (
              "-"
            ) : (
              <StatusField source="newStatus" />
            )}
          </>
        )}
      />
      <CustomPriceField label="Adjustment Amount" source="price" />
      <FunctionField
        label="Remark"
        render={(record: any) =>
          staticRemark ? staticRemark : record?.remark || "-"
        }
      />

      <FunctionField
        label="Updated By"
        render={(record: any) => (
          <>
            {record.updatedBy === null ? (
              "-"
            ) : (
              <UpdatedByField data={record.updatedBy} />
            )}
          </>
        )}
      />
    </Datagrid>
  );
};

const SubcontractorAdjustmentPriceStatusLogTable = ({
  basePath,
  filter,
  title = "",
  staticRemark,
  loggedAtSource = "loggedAt",
  showOldAndNewStatus = true,
  showPagination = true,
  pageSize = 10,
}: ISubcontractorAdjustmentPriceStatusLogTable) => {
  return (
    <SanitizedGrid container>
      {title && (
        <Grid item xs={12}>
          <Typography variant="subtitle2">{title}</Typography>
        </Grid>
      )}

      <Grid item xs={12}>
        <ResourceContextProvider value={basePath}>
          <PaddingDenseStyled2List
            basePath={`/${basePath}`}
            actions={false}
            exporter={false}
            hasCreate={false}
            filters={null}
            filter={filter || {}}
            sort={{ field: "UpdatedAt", order: "DESC" }}
            bulkActionButtons={false}
            title=" "
            pagination={showPagination ? <CustomPagination /> : false}
            perPage={pageSize}
            empty={
              <EmptyComponent
                message={title ? `No ${title.toLowerCase()} found` : null}
              />
            }
          >
            {showOldAndNewStatus ? (
              <CustomTwoColumnStatusDatagrid
                loggedAtSource={loggedAtSource}
                staticRemark={staticRemark}
              />
            ) : (
              <CustomOneColumnStatusDatagrid
                loggedAtSource={loggedAtSource}
                staticRemark={staticRemark}
              />
            )}
          </PaddingDenseStyled2List>
        </ResourceContextProvider>
      </Grid>
    </SanitizedGrid>
  );
};

export default SubcontractorAdjustmentPriceStatusLogTable;
